export default "__VITE_ASSET__CYXQ3Uod__"